(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[794],{

/***/ 82254:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/politika-konfidencialnosti",
      function () {
        return __webpack_require__(33067);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 82764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* reexport */ MetaHead; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(51759);
;// CONCATENATED MODULE: ./schemas/org/breadcrumbs/home.ts
var homeBreadcrumbsSchema = "{\n  \"@context\": \"http://schema.org/\",\n  \"@type\": \"BreadcrumbList\",\n  \"itemListElement\": [\n    {\n      \"@type\": \"ListItem\",\n      \"position\": 1,\n      \"name\": \"Главная\",\n      \"item\": \"https://bile-bile.kz/\"\n    }\n  ]\n}";

;// CONCATENATED MODULE: ./schemas/org/org.ts
var orgSchema = "{\n  \"@context\": \"http://schema.org/\",\n  \"@type\": \"Organization\",\n  \"name\": \"Bile-bile\",\n  \"logo\": \"https://bile-bile.kz/og-image.png\",\n  \"url\": \"https://bile-bile.kz/\",\n  \"address\": {\n    \"@type\": \"PostalAddress\",\n    \"addressCountry\": \"Kazakhstan\"\n  },\n  \"sameAs\": []\n}";

;// CONCATENATED MODULE: ./schemas/org/web.ts
var webSchema = "{\n  \"@context\": \"http://schema.org/\",\n  \"@type\": \"WebSite\",\n  \"url\": \"https://bile-bile.kz/\",\n  \"potentialAction\": {\n    \"@type\": \"SearchAction\",\n    \"target\": \"https://bile-bile.kz/search?origin={search_term_string}\",\n    \"query-input\": \"required name=search_term_string\"\n  }\n}";

;// CONCATENATED MODULE: ./schemas/org/faq.ts
var faqSchema = "{\n      \"@context\": \"http://schema.org/\",\n      \"@type\": \"FAQPage\",\n      \"mainEntity\": [\n        {\n          \"@type\": \"Question\",\n          \"name\": \"Хочу купить билет для ребёнка. Сколько стоит детский ж/д билет на поезд?\",\n          \"acceptedAnswer\": {\n            \"@type\": \"Answer\",\n            \"text\": \"Дети до 7 лет путешествуют на поезде бесплатно без предоставления отдельного места. Если детей до 7 лет двое или более, необходимо купить детский билет.  Для детей от 7 до 15 лет действует скидка в размере 50% от цены взрослого билета.  Для покупки детского билета понадобится свидетельство о рождении, удостоверяющее личность ребёнка. Если ребёнок едет не с родителями, нужно оформить доверенность на сопровождение.\"\n          }\n        },\n        {\n          \"@type\": \"Question\",\n          \"name\": \"Я хочу забронировать билет на поезд. Сколько времени действует бронь?\",\n          \"acceptedAnswer\": {\n            \"@type\": \"Answer\",\n            \"text\": \"Бронь на ж/д билет действует 30 минут. 15 минут на ввод данных пассажира и 15 минут на оплату.  После этого нужно заново забронировать билет.\"\n          }\n        },\n        {\n          \"@type\": \"Question\",\n          \"name\": \"На что обратить внимание при выборе ж/д билета?\",\n          \"acceptedAnswer\": {\n            \"@type\": \"Answer\",\n            \"text\": \"Рекомендуем обратить внимание на несколько важных моментов при бронировании ж/д билетов:  \xb7 Тип вагона: плацкарт, купе  От выбранного типа зависит стоимость билета и уровень комфорта во время поездки;  \xb7 Выбор места.  Вы можете выбрать любое место в вагоне. В плацкартных вагонах места у туалета с 33 до 38 номера, а в купейных -- с 33 по 36. Во всех поездах нижние полки -- это нечетные места, а верхние -- четные.\"\n          }\n        },\n        {\n          \"@type\": \"Question\",\n          \"name\": \"Я сделал ошибку в личных данных при покупке ж/д билета. Что делать?\",\n          \"acceptedAnswer\": {\n            \"@type\": \"Answer\",\n            \"text\": \"Если вы допустили ошибку в билете на поезд, сделайте возврат билета c главной страницы Bile-Bile → Возврат билета и оформите новый.\"\n          }\n        },\n        {\n          \"@type\": \"Question\",\n          \"name\": \"Какое максимальное количество билетов я могу приобрести в рамках оформления заказа?\",\n          \"acceptedAnswer\": {\n            \"@type\": \"Answer\",\n            \"text\": \"В рамках оформления заказа допускается приобретение 12 билетов. При необходимости увеличения количества билетов, необходимо оформить новый заказ\"\n          }\n        },\n        {\n          \"@type\": \"Question\",\n          \"name\": \"Какое подтверждение я получу после оплаты ж/д билета?\",\n          \"acceptedAnswer\": {\n            \"@type\": \"Answer\",\n            \"text\": \" Подтверждением заказа служит электронный билет, который вы получите после оплаты брони.  Мы также отправим билет на электронную почту или посредством SMS на реквизиты указанные при заказе билета  Электронный билет всегда доступен с главной страницы Bile-Bile → Печать билета и оформите новый\"\n          }\n        },\n        {\n          \"@type\": \"Question\",\n          \"name\": \"Необходимо ли иметь при себе билет при посадке в поезд?\",\n          \"acceptedAnswer\": {\n            \"@type\": \"Answer\",\n            \"text\": \"На наши поезда осуществляется посадка пассажира без необходимости предъявления билета (для резидентов РК по бар-коду удостоверения личности, на которое оформлялся заказ билета)\"\n          }\n        },\n        {\n          \"@type\": \"Question\",\n          \"name\": \"Я сделал возврат ж/д билета, купленного на Bile-Bile. Когда мне вернут деньги?\",\n          \"acceptedAnswer\": {\n            \"@type\": \"Answer\",\n            \"text\": \"Возврат платежей по Билетам, приобретенным по платежным картам, производится на банковский карт-счет, с которого производилась оплата, в течение 5 (пяти) рабочих дней с момента получения подтверждения возврата билета.\"\n          }\n        },\n        {\n          \"@type\": \"Question\",\n          \"name\": \"Как мне вернуть билет, если его за меня купил кто-то другой?\",\n          \"acceptedAnswer\": {\n            \"@type\": \"Answer\",\n            \"text\": \"Возврат билета оформляется c главной страницы Bile-Bile → Возврат билета, по реквизитам оформителя.\"\n          }\n        },\n        {\n          \"@type\": \"Question\",\n          \"name\": \"Я собираюсь вернуть неиспользованный билет, на что обратить внимание?\",\n          \"acceptedAnswer\": {\n            \"@type\": \"Answer\",\n            \"text\": \"Формирование запроса на возврат Билета  Возврат Билета производится круглосуточно через функционал Сайта. Возможно производить возврат одного или нескольких Билетов в Заказе.  Для возврата неиспользованного Билета необходимо пройти в раздел \xabВозврат билета\xbb, авторизоваться посредством указания электронного адреса или телефона, указанного во время оформления Билета и следовать дальнейшим инструкциям.  Возврат платежей по Билетам, приобретенным по платежным картам, производится на банковский карт-счет, с которого производилась оплата, в течение 5 (пяти) рабочих дней с момента получения подтверждения возврата Билета.  При оформлении возврата билета, сумма, уплаченная за Дополнительные услуги, возврату не подлежит.  Порядок удержания сумм при возврате Билета  За неиспользованные Билеты и несостоявшуюся вследствие этого перевозку багажа Перевозчик возвращает Пассажиру деньги в следующих случаях:  \xb7 не позднее, чем за 24 часа до отправления поезда - полную стоимость проезда;  \xb7 менее чем за 24 часа, но не позднее, чем за 6 (шесть) часов до отправления поезда - стоимость билета и 50 % (пятидесяти) стоимости плацкарты;  \xb7 менее чем за 6 часов до отправления и не более 1 (одного) часа после отправления поезда - стоимость билета, при этом удерживается вся стоимость плацкарты, но не более 30% от стоимости проезда.  По истечении 1 (одного) часа после отправления поезда возврат Билета не производится, денежные средства не возвращаются.\"\n          }\n        }\n      ]\n    }";

;// CONCATENATED MODULE: ./schemas/org/breadcrumbs/faq.ts
var faqBreadcrumbsSchema = "{\n  \"@context\": \"http://schema.org/\",\n  \"@type\": \"BreadcrumbList\",\n  \"itemListElement\": [\n    {\n      \"@type\": \"ListItem\",\n      \"position\": 1,\n      \"name\": \"FAQ\",\n      \"item\": \"https://bile-bile.kz/faq\"\n    }\n  ]\n}";

;// CONCATENATED MODULE: ./schemas/org/breadcrumbs/covid.ts
var covidBreadcrumbsSchema = "{\n  \"@context\": \"http://schema.org/\",\n  \"@type\": \"BreadcrumbList\",\n  \"itemListElement\": [\n    {\n      \"@type\": \"ListItem\",\n      \"position\": 1,\n      \"name\": \"COVID-19\",\n      \"item\": \"https://bile-bile.kz/covid\"\n    }\n  ]\n}";

;// CONCATENATED MODULE: ./schemas/org/breadcrumbs/contacts.ts
var contactsBreadcrumbsSchema = "{\n  \"@context\": \"http://schema.org/\",\n  \"@type\": \"BreadcrumbList\",\n  \"itemListElement\": [\n    {\n      \"@type\": \"ListItem\",\n      \"position\": 1,\n      \"name\": \"Контакты\",\n      \"item\": \"https://bile-bile.kz/contacts\"\n    }\n  ]\n}";

;// CONCATENATED MODULE: ./schemas/org/search.ts
var buildSearchSchema = function(param) {
    var origin = param.origin, destination = param.destination, departureTime = param.departureTime, arrivalTime = param.arrivalTime;
    return "{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"TrainReservation\",\n  \"reservationId\": \"AB3XY2\",\n  \"reservationStatus\": \"https://schema.org/ReservationConfirmed\",\n  \"reservationFor\": {\n    \"@type\": \"TrainTrip\",\n    \"departureStation\": {\n      \"@type\": \"TrainStation\",\n      \"name\": \"".concat(origin, "\"\n    },\n    \"departureTime\": \"").concat(departureTime, "\",\n    \"arrivalStation\": {\n      \"@type\": \"TrainStation\",\n      \"name\": \"").concat(destination, "\"\n    },\n    \"arrivalTime\": \"").concat(arrivalTime, "\"\n  }\n}");
};

;// CONCATENATED MODULE: ./schemas/org/landing.ts
var buildLandingSchema = function(param) {
    var origin = param.origin, destination = param.destination;
    return "{\n  \"@context\": \"http://schema.org/\",\n  \"@type\": \"WebPage\",\n  \"url\": \"https://bile-bile.kz/\",\n  \"name\": \"Купить дешевые ж/д билеты по направлению ".concat(origin, " - ").concat(destination, " | bile-bile.kz\",\n  \"description\": \"Bile-bile.kz ➤ дешевые ж/д билеты по направлению ").concat(origin, " - ").concat(destination, " ➤ Узнайте расписание, цены и покупайте железнодорожные билеты по выгодной цене.\",\n  \"publisher\": {\n    \"@type\": \"ProfilePage\",\n    \"name\": \"Bile-bile.kz - ТОО \xabNur-Kassa\xbb\"\n  }\n}");
};

;// CONCATENATED MODULE: ./schemas/org/breadcrumbs/routes.ts
var routesBreadcrumbsSchema = "{\n  \"@context\": \"http://schema.org/\",\n  \"@type\": \"BreadcrumbList\",\n  \"itemListElement\": [\n    {\n      \"@type\": \"ListItem\",\n      \"position\": 1,\n      \"name\": \"Все станции по направлениям\",\n      \"item\": \"https://bile-bile.kz/napravleniya\"\n    }\n  ]\n}";

;// CONCATENATED MODULE: ./components/shared/MetaHead/component.tsx

/* eslint-disable react/no-danger */ 



var SITE_URL = "https://bile-bile.kz" || 0;
var KZ_SITE_URL = "".concat(SITE_URL, "/kk");
var getSchemasByPage = function(page, extra) {
    if (page === 'home') return [
        homeBreadcrumbsSchema,
        orgSchema,
        webSchema
    ];
    if (page === 'faq') return [
        faqSchema,
        faqBreadcrumbsSchema
    ];
    if (page === 'covid') return [
        covidBreadcrumbsSchema
    ];
    if (page === 'contacts') return [
        contactsBreadcrumbsSchema
    ];
    if (page === 'search' || page === 'searchMulti') return [
        buildSearchSchema(extra)
    ];
    if (page === 'landing') return [
        buildLandingSchema(extra)
    ];
    if (page === 'routes') return [
        routesBreadcrumbsSchema
    ];
    return [];
};
var MetaHead = function(param) {
    var page = param.page, _extraParams = param.extraParams, extraParams = _extraParams === void 0 ? {} : _extraParams;
    var ref = (0,useTranslation/* default */.Z)('meta'), t = ref.t, lang = ref.lang;
    var router = (0,next_router.useRouter)();
    var title = t("".concat(page, ".title"), extraParams);
    var description = t("".concat(page, ".description"), extraParams);
    var pageSchemas = getSchemasByPage(page, extraParams);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }, "title"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: description
            }, "meta-description"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: title
            }, "og-title"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: "website"
            }, "og-website"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: description
            }, "og-description"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: "".concat(lang === 'ru' ? SITE_URL : KZ_SITE_URL).concat(router.asPath)
            }, "og-url"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: "".concat(SITE_URL, "/og-image.png")
            }, "og-image"),
            pageSchemas.map(function(schema, idx) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)("script", {
                    id: "schema-".concat(idx),
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(JSON.parse(schema))
                    }
                }, schema);
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/shared/MetaHead/index.ts



/***/ }),

/***/ 39636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* reexport */ StaticContent; },
  "X": function() { return /* reexport */ renderContentItem; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/ui/Box/index.ts + 2 modules
var Box = __webpack_require__(97243);
// EXTERNAL MODULE: ./components/ui/Typography/index.ts + 2 modules
var Typography = __webpack_require__(59253);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50445);
// EXTERNAL MODULE: ./node_modules/uniqid/index.js
var uniqid = __webpack_require__(76104);
var uniqid_default = /*#__PURE__*/__webpack_require__.n(uniqid);
// EXTERNAL MODULE: ./components/shared/StaticContent/styles.ts
var styles = __webpack_require__(62358);
;// CONCATENATED MODULE: ./components/shared/StaticContent/component.tsx






var renderHTMLContent = function(text) {
    var html = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (html) return(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        dangerouslySetInnerHTML: {
            __html: text
        }
    }));
    return text;
};
var renderContentItem = function(theme, contentItem, index, contentType) {
    var indent = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true, useHTML = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
    if (typeof contentItem === 'string') return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
        marginTop: indent ? 16 : 0,
        marginLeft: contentType === 'dots' ? 8 : 0,
        children: [
            contentType === 'numbers' && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* FloatedTypography */.US, {
                typography: theme.typography.variants.content.BOLD,
                children: index
            }),
            contentType === 'dots' && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                height: 19,
                display: "inline-block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* FloatedTypography */.US, {
                    dots: true,
                    typography: theme.typography.variants.title.H1,
                    children: String.fromCharCode(183)
                })
            }),
            "\xa0",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                children: renderHTMLContent(contentItem, useHTML)
            })
        ]
    }, index));
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
        marginTop: indent ? 16 : 0,
        marginLeft: contentType === 'dots' ? 8 : 0,
        children: [
            contentType === 'numbers' && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                typography: theme.typography.variants.content.BOLD,
                children: [
                    index,
                    "\xa0"
                ]
            }),
            contentType === 'dots' && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                height: 19,
                display: "inline-block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* FloatedTypography */.US, {
                    dots: true,
                    typography: theme.typography.variants.title.H1,
                    children: String.fromCharCode(183)
                })
            }),
            "\xa0",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                typography: contentItem.bold ? theme.typography.variants.content.BOLD : theme.typography.variants.content.MAIN,
                children: contentItem.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                children: [
                    typeof contentItem.content === 'string' && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        children: renderHTMLContent(contentItem.content, contentItem.useHTML)
                    }),
                    Array.isArray(contentItem.content) && contentItem.content.map(function(additionalContent, idx) {
                        return renderContentItem(theme, additionalContent, "".concat(index, ".").concat(idx + 1), contentItem.contentType, false);
                    })
                ]
            })
        ]
    }, index));
};
var StaticContent = function(param) {
    var content = param.content;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ContentWrapper */.vs, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
            marginTop: 24,
            children: content.map(function(offerItem, i) {
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(styles/* Paragraph */.nv, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                            typography: theme.typography.variants.title.H2,
                            children: [
                                i + 1,
                                ". ",
                                offerItem.title
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Paragraph */.nv, {
                            level: "second",
                            children: [
                                offerItem.content && typeof offerItem.content === 'string' && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                    children: renderHTMLContent(offerItem.content, offerItem.useHTML)
                                }),
                                offerItem.content && Array.isArray(offerItem.content) && offerItem.content.map(function(contentItem, k) {
                                    return renderContentItem(theme, contentItem, "".concat(i + 1, ".").concat(k + 1), 'numbers', true, offerItem.useHTML);
                                }),
                                offerItem.terms && offerItem.terms.map(function(term) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(styles/* Paragraph */.nv, {
                                        level: "second",
                                        children: !term.name ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            children: term.description
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                    typography: theme.typography.variants.content.BOLD,
                                                    children: term.name
                                                }),
                                                "\xa0 - ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                    children: term.description
                                                })
                                            ]
                                        })
                                    }, uniqid_default()());
                                })
                            ]
                        })
                    ]
                }, uniqid_default()());
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/shared/StaticContent/index.ts



/***/ }),

/***/ 62358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "vs": function() { return /* binding */ ContentWrapper; },
/* harmony export */   "US": function() { return /* binding */ FloatedTypography; },
/* harmony export */   "nv": function() { return /* binding */ Paragraph; }
/* harmony export */ });
/* harmony import */ var components_ui_Typography__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59253);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50445);


function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 920px;\n  span {\n    line-height: 1.5;\n  }\n\n  a {\n    color: ",
        ";\n    transition: all 0.2s ease;\n    &:hover {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  float: left;\n  line-height: ",
        ";\n  height: 19px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n        margin: 16px 0;\n        @media screen and (max-width: 768px) {\n          margin: 24px 0 8px;\n        }\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      margin: 16px 0;\n      @media screen and (max-width: 768px) {\n        margin: 8px 0;\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
var ContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-94a25945-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.palette.core.BLUE;
}, function(param) {
    var theme = param.theme;
    return theme.palette.secondary.MAIN;
});
var FloatedTypography = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(components_ui_Typography__WEBPACK_IMPORTED_MODULE_0__/* .Typography */ .Z).withConfig({
    componentId: "sc-94a25945-1"
})(_templateObject1(), function(param) {
    var dots = param.dots;
    return dots ? '1 !important' : 1.5;
});
var Paragraph = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-94a25945-2"
})(_templateObject4(), function(param) {
    var _level = param.level, level = _level === void 0 ? 'first' : _level;
    if (level === 'first') return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject2());
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject3());
});


/***/ }),

/***/ 41112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* reexport */ Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/ui/Box/index.ts + 2 modules
var Box = __webpack_require__(97243);
// EXTERNAL MODULE: ./components/ui/Icon/index.ts + 3 modules
var Icon = __webpack_require__(37033);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50445);
;// CONCATENATED MODULE: ./components/ui/Breadcrumbs/styles.ts

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      overflow-x: scroll;\n      overflow-y: hidden;\n      scrollbar-width: none;\n      -ms-overflow-style: none;\n      padding-bottom: 6px;\n\n      &::-webkit-scrollbar {\n        width: 0;\n        height: 0;\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      display: flex;\n      width: max-content;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  margin-right: 8px;\n  align-items: center;\n  font-size: 14px;\n  color: ",
        ";\n  transition: all 0.3s ease;\n  &:last-child {\n    color: ",
        ";\n\n    .icon {\n      display: none;\n    }\n  }\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
var ScrollWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a5491b52-0"
})(_templateObject1(), function(param) {
    var mobileScrollable = param.mobileScrollable;
    return mobileScrollable && (0,styled_components_browser_esm/* css */.iv)(_templateObject());
});
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a5491b52-1"
})(_templateObject3(), function(param) {
    var mobileScrollable = param.mobileScrollable;
    return mobileScrollable && (0,styled_components_browser_esm/* css */.iv)(_templateObject2());
});
var BreadcrumbLink = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-a5491b52-2"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.palette.core.DEEP_GRAY;
}, function(param) {
    var theme = param.theme;
    return theme.palette.text.MAIN;
}, function(param) {
    var theme = param.theme;
    return theme.palette.secondary.MAIN;
});

;// CONCATENATED MODULE: ./components/ui/Breadcrumbs/component.tsx






var Breadcrumbs = function(param) {
    var links = param.links, _mobileScrollable = param.mobileScrollable, mobileScrollable = _mobileScrollable === void 0 ? false : _mobileScrollable;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollWrapper, {
        mobileScrollable: mobileScrollable,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
            mobileScrollable: mobileScrollable,
            children: links.map(function(link) {
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(BreadcrumbLink, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            href: link.url,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: link.label
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                            marginLeft: 8,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                className: "icon",
                                color: theme.palette.core.DEEP_GRAY,
                                icon: theme.icons.core.BreadcrumbsArrow
                            })
                        })
                    ]
                }, link.url + link.label);
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/ui/Breadcrumbs/index.ts



/***/ }),

/***/ 33067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* reexport */ PrivacyPolicyPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/pages/static/content/policy.ts
var policy = [
    {
        title: 'Общие положения',
        content: [
            'Настоящая Политика конфиденциальности и обработки персональных данных (далее \xabПолитика\xbb) составлена в соответствии с требованиями закона Республики Казахстан от 21 мая 2013 года № 94-V \xabО персональных данных и их защите\xbb и определяет порядок сбора и обработки персональных данных Пользователей и Пассажиров, а также соответствующие меры по обеспечению безопасности персональных данных',
            'Настоящая Политика устанавливает порядок и цели сбора и обработки Персональных данных и является неотъемлемой частью Публичной оферты.',
            'Оператор прилагает максимальные технические, юридические и организационные меры для защиты Персональных данных. Однако, принимая во внимание увеличение количества несанкционированного доступа со стороны третьих лиц, Оператор не может гарантировать полной защиты Персональных данных.', 
        ]
    },
    {
        title: 'Термины и определения',
        terms: [
            {
                description: 'ТОО \xabNur-Kassa\xbb',
                name: 'Оператор'
            },
            {
                description: 'https://bile-bile.kz/',
                name: 'Сайт или Электронный информационный ресурс'
            },
            {
                description: 'данные, перечисленные в разделе \xabПерсональные данные, обрабатываемые Сайтом\xbb',
                name: 'Персональные данные'
            },
            {
                description: 'Пользователь и/или Пассажир',
                name: 'Субъект'
            },
            {
                name: '',
                description: 'Иные термины, определенные в Публичной оферте, имеют идентичное значение в Политике.'
            }, 
        ]
    },
    {
        title: 'Цели и порядок сбора и обработки персональных данных',
        content: [
            {
                description: 'Оператор осуществляет сбор и обработку Персональных данных Субъектов в целях:',
                contentType: 'numbers',
                content: [
                    'Оператор осуществляет сбор и обработку Персональных данных Субъектов в целях:',
                    'идентификации на Сайте;',
                    'предоставления поддержки Службы поддержки в ходе использования Сайта;',
                    'информирования посредством отправки электронных писем и смс сообщений, в том числе по вопросам, связанным с использованием Сайта;',
                    'предоставления информации о новых продуктах и услугах, специальных предложениях и различных событиях;',
                    'направления рекламных материалов;',
                    'анализа качества предоставляемых Услуг и улучшения качества обслуживания.', 
                ]
            },
            'Сбор Персональных данных и их обработка осуществляется Оператором на основании предоставления Персональных данных Субъектом либо его законным представителем путем добровольного заполнения соответствующих форм на Сайте.', 
        ]
    },
    {
        title: 'Персональные данные, обрабатываемые сайтом',
        content: [
            {
                description: 'Оператор с использованием функционала Сайта осуществляет сбор и обработку следующих Персональных данных:',
                contentType: 'none',
                content: [
                    '(1) Фамилия, имя, отчество;',
                    '(2) ИИН;',
                    '(3) Дата рождения;',
                    '(4) Пол;',
                    '(5) Данные документа, удостоверяющего личность, включая номер, дату и орган выдачи такого документа;',
                    '(6) Электронный адрес;',
                    '(7) Номер телефона.', 
                ]
            },
            'В случае предоставления Субъектом иных персональных данных Оператору вне функционала Сайта посредством обращения по контактным данным Оператора, Субъект дает согласие на сбор и обработку таких данных наравне с Персональными данными, указанными в настоящем Разделе, в соответствии с настоящей Политикой.', 
        ]
    },
    {
        title: 'Хранение и передача персональных данных третьим лицам',
        content: [
            'Безопасность персональных данных, которые обрабатываются Оператором, обеспечивается путем реализации правовых, организационных и технических мер, необходимых для выполнения требований действующего законодательства в области защиты персональных данных. Оператор обеспечивает сохранность персональных данных и принимает все возможные меры, исключающие доступ к персональным данным неуполномоченных лиц.',
            'Собранные Оператором Персональные данные хранятся на территории Республики Казахстан и не подлежат передаче третьим лицам без письменного согласия Субъекта Персональных данных, за исключением передачи Персональных данных в адрес Перевозчика и иных случаев, установленных законодательством Республики Казахстан.',
            'В случае осуществления трансграничной передачи, до начала осуществления трансграничной передачи персональных данных Оператор обязан убедиться в том, что иностранным государством, на территорию которого предполагается осуществлять передачу персональных данных, обеспечивается надежная защита прав субъектов персональных данных, либо  получить соответствующее согласие субъекта персональных данных на трансграничную передачу его персональных данных.', 
        ]
    },
    {
        title: 'Обезличивание и уничтожение персональных данных',
        content: [
            'После достижения целей сбора и обработки Персональных данных такие Персональные данные подлежат уничтожению.',
            'Помимо сбора Персональных данных на сайте производится сбор и обработка обезличенных данных о посетителях (в т.ч. файлов \xabcookie\xbb) с помощью сервисов интернет-статистики.',
            'Обезличенные данные Субъектов, собираемые с помощью сервисов интернет-статистики, служат для сбора информации о действиях Субъектов на сайте, улучшения качества сайта и его содержания.',
            'Субъект может в любой момент отозвать свое согласие на обработку персональных данных, направив Оператору уведомление посредством электронной почты на электронный адрес Оператора admin@bile-bile.kz с пометкой \xabОтзыв согласия\xbb. В случае отзыва согласия, данные, предоставленные Оператору, подлежат уничтожению в течение 5 (пяти) рабочих дней с момента получения информации об отзыве согласия.', 
        ]
    },
    {
        title: 'Заключительные положения и согласие пользователя',
        content: [
            'Субъект признает и соглашается, что регистрация Субъекта на Сайте, создание учетной записи и последующее использование Сайта и любого его функционала означает безоговорочное согласие Пользователя со всеми пунктами настоящей Политики, безоговорочное принятие ее условий и предоставление Оператору согласия на сбор и обработку Персональных данных.',
            'Оператор оставляет за собой право по своему личному усмотрению изменять и (или) дополнять Политику в любое время без предварительного и (или) последующего уведомления Пользователя. Новая редакция Политики вступает в силу с момента ее размещения на Сайте.',
            'Продолжение Субъектом использования Сайта после любых изменений Политики означает его согласие с такими изменениями и/или дополнениями. Субъект обязуется регулярно знакомиться с содержанием настоящей Политики в целях своевременного ознакомления с ее изменениями.',
            'Пользователь может получить любые разъяснения по интересующим вопросам, касающимся обработки его персональных данных, обратившись к Оператору.', 
        ]
    }, 
];

// EXTERNAL MODULE: ./components/shared/MetaHead/index.ts + 11 modules
var MetaHead = __webpack_require__(82764);
// EXTERNAL MODULE: ./components/shared/StaticContent/index.ts + 1 modules
var StaticContent = __webpack_require__(39636);
// EXTERNAL MODULE: ./components/ui/Box/index.ts + 2 modules
var Box = __webpack_require__(97243);
// EXTERNAL MODULE: ./components/ui/Breadcrumbs/index.ts + 2 modules
var Breadcrumbs = __webpack_require__(41112);
// EXTERNAL MODULE: ./components/ui/Container/index.ts + 2 modules
var Container = __webpack_require__(96429);
// EXTERNAL MODULE: ./components/ui/Typography/index.ts + 2 modules
var Typography = __webpack_require__(59253);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(51759);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50445);
// EXTERNAL MODULE: ./styles/mixins/page/pageWrapper.ts
var pageWrapper = __webpack_require__(25013);
;// CONCATENATED MODULE: ./components/pages/static/PrivacyPolicy/styles.ts


function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e88433f1-0"
})(_templateObject(), (0,pageWrapper/* pageWrapper */.Y)(false));

;// CONCATENATED MODULE: ./components/pages/static/PrivacyPolicy/component.tsx











var PrivacyPolicyPage = function() {
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var t = (0,useTranslation/* default */.Z)('staticPages').t;
    var breadcrumbs = [
        {
            url: '/',
            label: t('breadcrumbs.home')
        },
        {
            url: '/publichnaya-oferta',
            label: t('breadcrumbs.policy')
        }, 
    ];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaHead/* MetaHead */.w, {
                page: "privacyPolicy"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        marginTop: 32,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* Breadcrumbs */.O, {
                            links: breadcrumbs
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        marginTop: 24,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                            as: "h1",
                            typography: theme.typography.variants.title.H1,
                            children: t('policy.title')
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StaticContent/* StaticContent */.Y, {
                        content: policy
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/pages/static/PrivacyPolicy/index.ts


;// CONCATENATED MODULE: ./pages/politika-konfidencialnosti.tsx
var __N_SSP = true;



/***/ }),

/***/ 25013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ pageWrapper; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50445);

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding-top: ",
        "px;\n  position: relative;\n  min-height: calc(",
        ");\n  margin-bottom: ",
        "px;\n\n  @media screen and (max-width: 1180px) {\n    padding-top: 80px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var pageWrapper = function() {
    var useFullHeight = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, mt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 90, mb = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 96;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(_templateObject(), mt, useFullHeight ? '100vh' : 'calc(100vh - 90px)', mb);
};


/***/ }),

/***/ 76104:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(34155);
/* 
(The MIT License)
Copyright (c) 2014-2021 Halász Ádám <adam@aimform.com>
Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

//  Unique Hexatridecimal ID Generator
// ================================================

//  Dependencies
// ================================================
var pid = typeof process !== 'undefined' && process.pid ? process.pid.toString(36) : '' ;
var address = '';
if(false){ var i, networkInterfaces, mac, os; } 

//  Exports
// ================================================
module.exports = module.exports["default"] = function(prefix, suffix){ return (prefix ? prefix : '') + address + pid + now().toString(36) + (suffix ? suffix : ''); }
module.exports.process = function(prefix, suffix){ return (prefix ? prefix : '') + pid + now().toString(36) + (suffix ? suffix : ''); }
module.exports.time    = function(prefix, suffix){ return (prefix ? prefix : '') + now().toString(36) + (suffix ? suffix : ''); }

//  Helpers
// ================================================
function now(){
    var time = Date.now();
    var last = now.last || time;
    return now.last = time > last ? time : last + 1;
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(82254); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);